import i from "./index.ce.vue.js";
import { defineAndRegisterElement as e } from "../../utils/register-element.js";
const t = e(i);
export {
  t as initAiCancelDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-cancel-dialog/index.js
// module id = 1151
// module chunks = 41